module.exports = __webpack_public_path__ + "img/partner_3.7d378b1.png";